import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const EquipmentDetailsModal = ({ show, onClose, activeTab, setActiveTab, data, departmentName }) => {
  const tabs = [
    { id: 'Delivered', label: 'Delivered', color: '#4ade80' },
    { id: 'Not Delivered', label: 'Not Delivered', color: '#facc15' },
    { id: 'Not Ordered', label: 'Not Ordered', color: '#ef4444' }
  ];

  const ships = (data || []).map(item => item.ship);
  const [selectedShip, setSelectedShip] = useState(ships[0] || '');
  
  useEffect(() => {
    if (ships.length && !ships.includes(selectedShip)) setSelectedShip(ships[0]);
  }, [ships.join(','), selectedShip]);

  if (!show) return null;

  const selectedShipObj = (data || []).find(item => item.ship === selectedShip) || { equipment_details: [] };
  const filteredEquipment = selectedShipObj.equipment_details.filter(eqpt => eqpt.status === activeTab);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[80vh] flex flex-col">
        <div className="flex justify-between items-center rounded-t-xl bg-[#1e3a8a] px-6 py-4">
          <h2 className="text-xl font-bold text-white">Equipment Details - {departmentName}</h2>
          <button onClick={onClose} className="text-white hover:text-gray-200">
            <X size={24} />
          </button>
        </div>
        <div className="p-6 pt-4 flex-1 flex flex-col">
          {ships.length > 1 && (
            <div className="mb-4 flex items-center gap-2">
              <label htmlFor="ship-select" className="text-sm font-medium text-gray-700">Ship:</label>
              <select
                id="ship-select"
                value={selectedShip}
                onChange={e => setSelectedShip(e.target.value)}
                className="form-select rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 text-sm bg-white min-w-0 w-auto max-w-[120px]"
              >
                {ships.map(ship => (
                  <option key={ship} value={ship}>{ship}</option>
                ))}
              </select>
            </div>
          )}
          <div className="flex gap-2 mb-4 border-b">
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-4 py-2 font-medium text-sm rounded-t-lg transition-colors ${
                  activeTab === tab.id
                    ? 'bg-white border-b-2 border-indigo-600 text-indigo-600'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <div className="overflow-y-auto flex-1 max-h-[50vh]">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Equipment Name</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Equipment Code</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredEquipment.length === 0 ? (
                  <tr><td colSpan={3} className="text-center py-8 text-gray-400">No equipment found.</td></tr>
                ) : filteredEquipment.map((eqpt, idx) => (
                  <tr key={eqpt.equipment_id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{eqpt.equipment_name}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{eqpt.equipment_code}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span
                        className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                          eqpt.status === 'Delivered' ? 'bg-green-100 text-green-700' :
                          eqpt.status === 'Not Delivered' ? 'bg-yellow-100 text-yellow-700' :
                          'bg-red-100 text-red-700'
                        }`}
                      >
                        {eqpt.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EquipmentDetailsModal;